import {
    FETCH_RN_PENDING_REPORT_REQUEST_DK,
    FETCH_RN_PENDING_REPORT_SUCCESS_DK,
    FETCH_RN_PENDING_REPORT_FAILURE_DK,
    FETCH_RN_PENDING_REPORTS_STYLE_WISE_SUCCESS,
    FETCH_RN_PENDING_REPORTS_STYLE_WISE_FAILURE,
    FETCH_RN_PENDING_REPORTS_STYLE_WISE_REQUEST,

    FETCH_COMPACTING_OR_OTHERS_CUTTING_REPORT_REQUEST,
    FETCH_COMPACTING_OR_OTHERS_CUTTING_REPORT_FAILURE,
    FETCH_COMPACTING_OR_OTHERS_CUTTING_REPORT_SUCCESS,
    FETCH_RN_IN_STOCK_REPORTS_SUCCESS,
    FETCH_RN_IN_STOCK_REPORTS_FAILURE,
    FETCH_RN_IN_STOCK_REPORTS_REQUEST
} from './rnPendingReport.actionType';

export const RN_PENDING = 'rnpending';

let initialState = {
    loading: false,
    reportRNPendingList: [],
    styleMasterList: [],
    reportComporOthertCutList: [],

};

export let rnpendinreportReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_RN_PENDING_REPORT_REQUEST_DK:
        case FETCH_RN_PENDING_REPORTS_STYLE_WISE_REQUEST:
        case FETCH_COMPACTING_OR_OTHERS_CUTTING_REPORT_REQUEST:
        case FETCH_RN_IN_STOCK_REPORTS_REQUEST:
            return {
                ...state,
                loading: true
            };

        case FETCH_RN_PENDING_REPORT_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                reportRNPendingList: updatePayload?.RN
            };
        case FETCH_COMPACTING_OR_OTHERS_CUTTING_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                reportCompCutList: updatePayload?.RN
            };
        case FETCH_RN_PENDING_REPORTS_STYLE_WISE_SUCCESS:
            return {
                ...state,
                loading: false,
                styleMasterList: updatePayload
            };
        case FETCH_RN_IN_STOCK_REPORTS_SUCCESS:
            return {
                ...state,
                loading: false,
                rnInStockReportsData: updatePayload?.RN
            };
        case FETCH_RN_PENDING_REPORT_FAILURE_DK:
        case FETCH_RN_PENDING_REPORTS_STYLE_WISE_FAILURE:
        case FETCH_COMPACTING_OR_OTHERS_CUTTING_REPORT_FAILURE:
        case FETCH_RN_IN_STOCK_REPORTS_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
